<div class="container padding-top padding-bottom">
  <md-card *ngIf="unitSizes && locationData; else loading">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>{{ clientData?.name}}</h1>
        <h3>{{ locationData?.name}}</h3>
      </div>
      <div class="col-md-12">
        <h2>Size Guide Settings</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 sm-padding-top">
        <md-slide-toggle (change)="updateShowButtons($event)"
                         [(ngModel)]="locationData?.sizeGuide.hideButtons">
          <p> Hide Rent and Reserve Buttons on size guide</p>
        </md-slide-toggle>
        <br>
        <label for="page-title">Page Title</label>
        <input class="full-width"
               pInputText
               id="page-title"
               (change)="savelocationData()"
               [(ngModel)]="locationData.sizeGuide.title" />
        <label for="page-body">Page Body (HTML allowed)</label>
        <p-editor id="page-body"
                  class="full-width"
                  (change)="savelocationData()"
                  [(ngModel)]="locationData.sizeGuide.body"
                  [style]="{'height':'320px'}">
          <p-header>
            <span class="ql-formats">
              <button class="ql-bold"
                      aria-label="Bold"></button>
              <button class="ql-italic"
                      aria-label="Italic"></button>
              <button class="ql-underline"
                      aria-label="Underline"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list"
                      value="ordered"
                      aria-label="List Ordered"></button>
              <button class="ql-list"
                      value="bullet"
                      aria-label="List"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-link"
                      aria-label="Link"></button>
              <button class="ql-image"
                      aria-label="Image"></button>
            </span>
          </p-header>
        </p-editor>
        <!--<textarea class="full-width" pInputTextarea id="page-body" autoResize="autoResize"-->
        <!--[(ngModel)]="pageSettings.sizeGuide.body"></textarea>-->
      </div>

    </div>
    <hr>
    <div class="row">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
      </div>
    </div>
  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-size-guide/location-size-guide.component.html